import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import elaine from '../assets/images/about/aboutHTML_elaine.jpeg';
import studio_01 from '../assets/images/about/studio_01.jpeg';
import studio_02 from '../assets/images/about/studio_02.jpeg';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from '../components/Section';


const About = () => {

  const isMobile = useMediaQuery({ maxWidth: 401 });
  const isSmallTablet = useMediaQuery({ minWidth: 402, maxWidth: 701 });
  const isTablet = useMediaQuery({ minWidth: 702, maxWidth: 901 })
  const isSmallDesktop = useMediaQuery({ minWidth: 902, maxWidth: 1001 });
  const isDesktop = useMediaQuery({ minWidth: 1002 });

  const [flexDirection, setFlexDirection] = useState('flex-row');
  const [elaineImg, setElaineImg] = useState('26rem');
  const [textWidth, setTextWidth] = useState('w-50');

  
  useEffect(() => {
    if (isMobile) {
      setFlexDirection('flex-column');
      setElaineImg('98vw');
      setTextWidth('w-100');
    }

    if (isSmallTablet) {
      setFlexDirection('flex-column');
      setElaineImg('26rem');
      setTextWidth('w-100');
    }
    
    if (isTablet) {
      setFlexDirection('flex-column');
      setElaineImg('26rem');
      setTextWidth('w-75');
    }
    
    if (isSmallDesktop) {
      setFlexDirection('flex-row');
      setElaineImg('26rem');
      setTextWidth('w-50');
    }

    if (isDesktop) {
      setFlexDirection('flex-row');
      setElaineImg('26rem');
      setTextWidth('w-50');
    }

  }, [isMobile, isSmallTablet, isTablet, isSmallDesktop, isDesktop]);


  return (

    <>

      <Navbar/>


      <Section>
        <h2 className={`mx-2 font-custom text-center`}>About Art Alive Art School</h2>
      </Section>
      
      <Section>
        <div className={`d-flex ${flexDirection} gap-3 justify-content-center align-items-center`}>
          <div className='d-flex gap-3' style={{ width: elaineImg }}>
            <div className={`card text-bg-dark text-center`}>
              <img src={studio_02} className="card-img img-fluid" style={{ objectFit: 'cover', height: '100%' }}  />
            </div>
            <div className={`card text-bg-dark text-center`}>
              <img src={studio_01} className="card-img img-fluid" style={{ objectFit: 'cover', height: '100%' }}  />
            </div>
          </div>
          <div className={`px-2 ${textWidth} d-flex flex-column justify-content-center`}>
            <p>Art Alive Art School is a welcoming creative space where art is more than a skill. It is a journey of growth confidence and connection.</p>
            <p>We believe everyone has an artistic voice waiting to be discovered or rediscovered. Whether you are picking up a pencil for the first time returning to art after many years or wanting to refine your technique our classes are designed to meet you where you are.</p>
          </div>
        </div>
      </Section>

      <Section>
        <div className={`d-flex gap-3 ${flexDirection} justify-content-center align-items-center`}>
          <div className={`card text-bg-dark text-center`} style={{ width: elaineImg }}>
            <img className="card-img img-fluid" style={{ objectFit: 'cover', height: '100%' }} src={elaine} alt="Elaine Marx, Founder of Art Alive Art School" />
          </div>
          <div className={`px-2 ${textWidth} d-flex flex-column justify-content-center`}>
            <p>Our experienced and passionate teachers guide students step by step in a relaxed supportive environment. Students explore a wide range of mediums including graphite charcoal pencil pastels watercolours acrylics oil painting and sculpture. This variety allows each artist to discover what resonates with them while building strong foundational skills.</p>
            <p>From children to adults each student is encouraged to grow at their own pace and in their own style. We focus on both technical development and personal expression always leaving space for curiosity experimentation and joy.</p>
            <p>Art Alive is also a community. A place where creativity is shared stories are told and confidence quietly builds. We celebrate progress rather than perfection and believe that art has the power to bring calm meaning and a sense of belonging into everyday life.</p>
          </div>
        </div>
      </Section>

      <Section>
        <h2 className={`px-2 font-custom text-center`}>Together we bring your art alive</h2>
      </Section>


      <Footer />
    
    </>

  );

}

export default About;